import { Component, ChangeDetectionStrategy } from '@angular/core';
import { I18nService } from '@digilize/shared/feature/modules/i18n/src';

@Component({
  selector: 'plyc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent {
  constructor(private i18nService: I18nService) {
    this.i18nService.init();
  }
}
